import { toast } from "react-toastify";
import { toastErrorOptions } from "../App";

export /**
 *
 * Displays a toast for the given errors
 * @param {*} err
 * @return {*}
 */
const handleGraphQLErrors = (err) => {
  const isNetwork = err?.networkError;

  if (isNetwork) {
    toast("Network error, please check your connection", toastErrorOptions);
    return;
  }

  if (err?.graphQLErrors?.length > 0) {
    const errors = err?.graphQLErrors?.map((x) => x.message);
    // Side effect - Display toasts, one for each error.
    errors.map((error) => toast(error, toastErrorOptions));
    return;
  }
};
